import translate from './translate.js';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  translate: [ 'value', translate ]
};